import Button from "../Button";
import FormLink from "../FormLink";
import TextInput from "../FormElements/TextInput";
import signupImage from "../../assets/signupImage.png";
import styles from "../../sections/Register/register.module.scss";
import { useHistory } from "react-router-dom";
import HomeBuddyLogo from "../../assets/HomeBuddy_RequestedColour_PrimaryLockup.svg";

interface IOtpVerificationAccount {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  otp: string;
  email: string;
  loading: boolean;
  resendLink: string;
}

// Same layout as LoginAccount, for the second sign-in step.
const OtpVerificationAccount: React.FC<IOtpVerificationAccount> = ({
  handleChange,
  onSubmit,
  otp,
  email,
  loading,
  resendLink,
}) => {
  const history = useHistory();
  return (
    <div className={styles.formContainerI}>
      <div className={styles.loginform}>
        <div className={styles.logoContainerI}>
          <div
            className={styles.logoImage}
            role="button"
            onClick={() => history.push("/")}
          >
            <img src={HomeBuddyLogo} alt="HomeBuddyLogo" />
          </div>
        </div>

        <div className={styles.logoContainerWel}>
          <span className={styles.welcome}>Verify It's You</span>
        </div>

        <form onSubmit={onSubmit} action="#" className={styles.innerLogin}>
          <p>
            We sent a one-time password to <strong>{email}</strong>. Enter it
            below to finish signing in.
          </p>
          <TextInput
            type="text"
            name="otp"
            placeholder="OTP*"
            required={true}
            onChange={handleChange}
            value={otp}
            inputMode="numeric"
            maxLength={6}
            autoFocus
          />
          <Button
            label="VERIFY"
            classes={"theme-btn-1 btn btn-block self-center"}
            disabled={loading}
          />
        </form>

        <div className={`${styles.noaccount} account-create pt-100`}>
          <h4>DIDN'T GET THE CODE?</h4>
          <p>
            Codes expire after 10 minutes. Sign in again to have a new one sent
            to your email.
          </p>
          <div className="btn-wrapper">
            <FormLink
              link={resendLink}
              classes={"theme-btn-1 btn black-btn"}
              text="RESEND CODE"
            />
          </div>
        </div>
      </div>

      <div className={styles.sideImgContainer}>
        <img src={signupImage} alt="signupImage" className={styles.sideImg} />
      </div>
    </div>
  );
};

export default OtpVerificationAccount;
